module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-stone-path-remnants.4e258095.png";